import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui';
import { makeStyles } from 'tss-react/mui';
import HelpIcon from '@mui/icons-material/Help';
import { colors, dotmapsBlack80 } from '@constants/colors';

// Matches the original hand-rolled Popover+Paper's look (fontSize/maxWidth/padding/text
// color), since Tooltip's own default bubble (dark background, white text, tight padding)
// replaces it entirely rather than inheriting from it. dotmapsBlack80 (not pure black) is
// this app's standard body-text color, and comfortably clears WCAG AA contrast on white.
const useStyles = makeStyles()(theme => ({
  tooltip: {
    backgroundColor: colors.neutral.white,
    color: dotmapsBlack80,
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    fontSize: '0.875rem',
    maxWidth: '18rem',
    padding: theme.spacing(2)
  }
}));

// A real Tooltip (rather than a hand-rolled hover-only Popover) so this opens on keyboard
// focus as well as mouse hover, and is linked to the icon via aria-describedby automatically.
const FieldHelpIcon = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Tooltip title={children} classes={{ tooltip: classes.tooltip }}>
      <HelpIcon
        aria-hidden={false}
        htmlColor="#999999"
        style={{ fontSize: '1rem', paddingLeft: '0.5rem' }}
        tabIndex={0}
      />
    </Tooltip>
  );
};

FieldHelpIcon.propTypes = {
  children: PropTypes.node
};

export default FieldHelpIcon;
